import React from 'react';
import DatePicker from 'react-datepicker';
import request from '@/services/request.service';
import { toFormData } from '@/utils/convert.util';
import { timeConverter } from '@/utils/convert.util';
import 'react-datepicker/dist/react-datepicker.css';
import { getLocaleWordContent } from '@/utils/language.util';

export default function Calender({ btype, startDate, setStartDate, endDate, setEndDate, setLst }) {
    const getList = async () => {
        const param = {
            m_code: 1000002,
            b_type: btype,
            sdate: timeConverter(startDate),
            edate: timeConverter(endDate),
        };
        const rsp = await request
            .post('/api/bonus/bonus_hist.php', toFormData(param))
            .then((response) => response.data);
        if (rsp.result < 0) {
            alert(rsp.msg);
            return rsp;
        } else {
            alert('ok');
            setLst(rsp.list);
        }
    };
    const onSubmit = (e) => {
        if (e) e.preventDefault();
        getList();
    };
    return (
        <>
            <div className="box">
                <form className="inputbox">
                    <div className="d_flex">
                        <div className="date_start">
                            <p>
                                Form<span className="red">*</span>
                            </p>

                            <DatePicker
                                showIcon
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                placeholderText="Date"
                            />
                        </div>

                        <div className="date_end">
                            <p>
                                To<span className="red">*</span>
                            </p>
                            <DatePicker
                                showIcon
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                placeholderText="Date"
                                className="input01"
                            />
                        </div>
                    </div>
                    <div className="bottom-btn">
                        <button type="button" className="b_blue btn01" onClick={onSubmit}>
                            {getLocaleWordContent('검색')}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}
